import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  GungAnonymousConfigService,
  GungFlowService,
  PriceConfigService,
  PriceService,
  ProductGridViewComponent
} from 'gung-standard';

@Component({
    selector: 'colmec-top-product-grid-view',
    templateUrl: './colmec-top-product-grid-view.component.html',
    styleUrls: ['./colmec-top-product-grid-view.component.scss'],
    standalone: false
})
export class ColmecTopProductGridViewComponent extends ProductGridViewComponent {
  public hidePrice = false;

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    private priceConfigService: PriceConfigService,
    protected router: Router
  ) {
    super(priceService, gungFlowService, authService, gungAnonymousConfigService, router);

    this.priceConfigService.hidePrice.subscribe(hidePrice => (this.hidePrice = hidePrice));
  }
}
